import React, { useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import Table from "../../../../core/common/dataTable/index";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link } from 'react-router-dom';
import DateRangePicker from 'react-bootstrap-daterangepicker';
// import ClientVisitSidebar from './ClientVisitsidebar/ClientVisitSidebar';
import CustomSelect from '../../../../core/common/selectPirority/SelectPirority';
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import { ClientData } from '../../ProjectTabs/ClientVisit/ClientData';
import TextField from '../../../../core/common/textFields/TextField';
import { useTableSelection } from '../../../../core/hooks/useTableSelection';
import { useGetAllContactsQuery } from '../../../../services/EndPointsApis';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound';
import LeadContactsSidebar from './LeadContactsSidebar';
import FilterModalContacts from './FilterModalContacts';
import ExistingContactModal from './ExisitngContactsModal';
import FilterComponent from '../../../../core/common/FilterComponent';


const LeadContacts = () => {

  //   const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [searchStr, setSearchStr] = useState('s'); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");

  const { data: allContacts, refetch: refetchContacts, isLoading } = useGetAllContactsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || ' ',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });

  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: contactData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
  } = useTableSelection(allContacts?.result?.data || [], 'contactId');

  const [viewOnly, setViewOnly] = useState(false)
  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
const idValue='dropdownMenuClickableInsise1';
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }
  const handleContactModal = () => {
    setShowContactModal(true)
  }

  const handleAddContacts = () => {
    setActivityTogglePopup(true);
    setIsEditing(false);
    setIsViewOnly(false)
  };

    const handleEditContacts = () => {
      setActivityTogglePopup(true);
      setIsEditing(true)
      setIsViewOnly(false)

    };
  //   const handleViewClientVisit = () => {
  //     setActivityTogglePopup(true);
  //     setIsEditing(false)
  //     setIsViewOnly(true)
  //   };

  const closeSidebar = () => {
    setActivityTogglePopup(false);
  };

  const handleClose = () => {
    setShowfilterModal(false)
    setShowContactModal(false);
  };
  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];

  //   const disable = selectedRowId.length > 1 || selectedRowId.length === 0;

  //   const handleRowDoubleClick = (record: { id: string }) => {
  //     const id = record.id;
  //     handleViewClientVisit();
  //   };

  return (
    <>
      <LeadContactsSidebar activityTogglePopup={activityTogglePopup} viewOnly={viewOnly} closeSidebar={closeSidebar} isEditing={isEditing} contactData={contactData} refetchContacts={refetchContacts} />
      <FilterModalContacts show={showfilterModal} handleClose={handleClose} />
      <ExistingContactModal show={showContactModal} handleClose={handleClose} />

      {/* <ClientVisitSidebar activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar} isEditing={isEditing} isViewOnly={isViewOnly} /> */}
      <div className='row'>
        <div className='col-md-12'>
          <div className="card main-card">
            <div className="card-body">
              {/* Search */}
              <div className="search-section">
                <div className="row">
                  <div className='col-md-5'>
                    <div className='d-flex gap-2'>
                      <div className=" icon-form">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                        />
                      </div>
                      <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-8">
                    <div className='d-flex justify-content-end gap-3 '>
                      <button className="btn btn-transparent border-0 p-0" onClick={handleContactModal}><span className='me-1'><i className='fa fa-plus'></i></span>Add Existing Contact</button>

                      <button className="btn btn-transparent border-0 p-0" disabled={!isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleEditContacts}><span className='me-2'>{svgIcons.updateIcon}</span>Edit</button>
                      <button className="btn btn-primary" disabled={isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleAddContacts}>+ New Contacts </button>
                    </div>
                  </div>
                </div>


              </div>
              {/* Contact List */}
              <table className="table datanew dataTable no-footer table-hover">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        className='form-check-input cursor-pointer'
                        checked={isTableHeadChecked}
                        onChange={handleTableHeadChange}
                      />
                    </th>
                    <th>ID</th>
                    <th>NAME</th>
                    <th>CONTACT</th>
                    <th>EMAIL</th>
                    <th>LOCATION</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && <>
                    {allContacts?.result?.value?.result?.data?.length > 0 ? (
                      <>
                        {allContacts?.result?.value?.result?.data.map((data: any, index: any) => {
                          return (
                            <tr key={data.contactId} onClick={() => handleRowClick(data)}
                              className={selectedIndividualCheckboxId.includes(data.contactId) ? 'selected-row' : ''}>
                              <td>
                                <TextField
                                  type="checkbox"
                                  fieldClass='form-check-input cursor-pointer'
                                  checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.contactId)}
                                  onChange={(e) => handleCheckItem(e, data)}
                                />
                              </td>
                              <td>{data?.contactNo}</td>
                              <td>{data?.firstName} {data?.lastName}</td>
                              <td>{data?.workPhone}</td>
                              <td>{data?.workEmail}</td>
                              <td>{data?.city}</td>

                              <td>
                                {data?.status !== true ? (
                                  <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                ) : (
                                  <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                )}
                              </td>
                            </tr>
                          )
                        })}
                      </>
                    ) :
                      (<tr>
                        <td colSpan={7}>
                          <NoRecordFound />
                        </td>
                      </tr>)}
                  </>
                  }
                  {isLoading &&
                    <TableLoading />
                  }
                </tbody>
              </table>
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="TableData-length" />
                </div>
                <div className="col-md-6">
                  <div className="TableData-paginate" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default LeadContacts
